import { render, staticRenderFns } from "./NotifyReturn.vue?vue&type=template&id=96e60216"
import script from "./NotifyReturn.vue?vue&type=script&lang=js"
export * from "./NotifyReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports